import { canv } from "@/canv/global.js";
import type { textWidget } from "@/elements/text/text";
import { Shape } from "../shape";

export class ShapeBraceLeft extends Shape {
    needFill = false;
    fillStyleEnabled = false;
    borderStyleEnabled = false;

    fitText(
        textPart: textWidget,
        x: number,
        y: number,
        width: number,
        height: number,
        verticalPadding: number,
        horizontalPadding: number,
    ) {
        const allowedWidth = (width * 18) / 20 - 2 * horizontalPadding;
        const allowedHeight = height - 2 * verticalPadding;

        textPart.hardWidth = allowedWidth;
        textPart.fitShape();
        textPart.updateDims();

        textPart.startX = x + (width * 18) / 20 / 2 - textPart.width / 2;
        textPart.startY = y + textPart.lines[0].textHeight + height / 2 - textPart.height / 2;

        textPart.updateDims();

        return {
            allowedWidth: allowedWidth,
            allowedHeight: allowedHeight,
        };
    }

    draw(x: number, y: number, width: number, height: number) {
        const r = width / 150;

        canv.ctx.beginPath();
        canv.ctx.moveTo(x + width, y + height);
        canv.ctx.arcTo(
            x + (width * 19) / 20,
            y + (height * 19) / 20,
            x + (width * 19) / 20,
            y + (height * 11) / 20,
            r,
        );
        canv.ctx.lineTo(x + (width * 19) / 20, y + (height * 11) / 20);
        canv.ctx.lineTo(x + (width * 18) / 20, y + (height * 10) / 20);
        canv.ctx.lineTo(x + (width * 19) / 20, y + (height * 9) / 20);
        canv.ctx.arcTo(x + (width * 19) / 20, y + (height * 1) / 20, x + width, y, r);
        canv.ctx.lineTo(x + width, y);
        canv.ctx.moveTo(x + width, y);
        canv.ctx.closePath();
    }

    getView(reason = "shapeToolSubMenu", bgColor = "white", borderColor = "black") {
        let width = 24;
        let height = 24;
        let fill = "white";
        let stroke = "black";

        if (reason === "shapeToolSubMenu") {
            width = 24;
            height = 24;
            fill = "";
            stroke = "#7C7C91";
        } else if (reason === "shapeLibrary") {
            width = 30;
            height = 30;
        } else if (reason === "voteResult") {
            width = 170;
            height = 170;
            fill = bgColor;
            stroke = borderColor;
        }

        return `
            <svg width="${width}" height="${height}" viewBox="0 0 12 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path stroke="${stroke}" d="M11.2273 26H10.0909C8.88534 26 7.7292 25.5211 6.87682 24.6686C6.02432 23.8162 5.54545 22.6601 5.54545 21.4545V18.0455C5.54545 17.1414 5.18625 16.2742 4.54693 15.6349C3.90762 14.9956 3.04051 14.6364 2.13636 14.6364C1.83498 14.6364 1.54594 14.5166 1.33283 14.3035C1.11973 14.0905 1 13.8014 1 13.5C1 13.1986 1.11973 12.9095 1.33283 12.6965C1.54594 12.4834 1.83498 12.3636 2.13636 12.3636C3.04051 12.3636 3.90762 12.0044 4.54693 11.3651C5.18625 10.7258 5.54545 9.85869 5.54545 8.95455V5.54545C5.54545 4.33992 6.02432 3.18377 6.87682 2.33133C7.7292 1.4789 8.88534 1 10.0909 1H11.2273"/>
            </svg>
        `;
    }
}
